import React from 'react';
import { MapPin } from 'lucide-react';
export function ServiceAreasSection() {
  const cities = ['Chandler, AZ', 'Gilbert, AZ', 'Queen Creek, AZ', 'Mesa, AZ', 'Phoenix, AZ', 'Paradise Valley, AZ', 'Scottsdale, AZ', 'Fountain Hills, AZ', 'San Tan Valley, AZ', 'Tempe, AZ'];
  return <section className="w-full bg-[var(--brand-black)] py-20 lg:py-28 relative overflow-hidden" data-id="element-162">
      {/* Subtle background graphic */}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-1/2 h-full opacity-5 pointer-events-none" data-id="element-163">
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full fill-white" data-id="element-164">
          <path d="M45.7,-76.3C58.9,-69.3,69.1,-55.3,77.5,-40.7C85.9,-26.1,92.5,-11,91.3,3.5C90.1,18,81.1,31.9,70.9,43.8C60.7,55.7,49.3,65.6,35.8,72.7C22.3,79.8,6.7,84.1,-8.2,82.6C-23.1,81.1,-37.3,73.8,-49.8,64.2C-62.3,54.6,-73.1,42.7,-80.4,28.6C-87.7,14.5,-91.5,-1.8,-88.2,-16.6C-84.9,-31.4,-74.5,-44.7,-61.8,-53.4C-49.1,-62.1,-34.1,-66.2,-20.2,-70.6C-6.3,-75,6.5,-79.7,21.1,-80.1C35.7,-80.5,45.7,-76.3,45.7,-76.3Z" transform="translate(100 100)" data-id="element-165" />
        </svg>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-166">
        <div className="text-center md:text-left mb-12" data-id="element-167">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white uppercase tracking-wider mb-4" data-id="element-168">
            Proudly Serving the Greater Phoenix Area
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-169">
          <div className="w-full lg:w-1/2" data-id="element-170">
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-8" data-id="element-171">
              {cities.map((city, index) => <li key={index} className="flex items-center text-gray-300 text-lg hover:text-white transition-colors cursor-pointer group" data-id="element-172">
                  <span className="w-2 h-2 rounded-full bg-[var(--brand-gold)] mr-4 group-hover:scale-150 transition-transform" data-id="element-173"></span>
                  {city}
                </li>)}
            </ul>
          </div>

          <div className="w-full lg:w-1/2 flex justify-center lg:justify-end" data-id="element-174">
            <div className="w-full max-w-md aspect-square rounded-full border border-white/10 flex items-center justify-center relative bg-white/5 backdrop-blur-sm" data-id="element-175">
              <MapPin className="w-16 h-16 text-[var(--brand-gold)] animate-bounce" data-id="element-176" />
              {/* Decorative rings */}
              <div className="absolute inset-0 rounded-full border border-[var(--brand-gold)]/30 animate-ping" style={{
              animationDuration: '3s'
            }} data-id="element-177"></div>
              <div className="absolute inset-8 rounded-full border border-[var(--brand-gold)]/20" data-id="element-178"></div>
              <div className="absolute inset-16 rounded-full border border-[var(--brand-gold)]/10" data-id="element-179"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}